import type { GiftPassDetail } from '../../api/gift-passes';

import { eventCountLabel } from './gift-passes-model';
import { GiftPassCardHeading } from './GiftPassCardHeading';
import { GiftPassEventItem } from './GiftPassEventItem';

export function GiftPassActivityCard({ pass }: { pass: GiftPassDetail }) {
  return (
    <section className="nb-card nb-card-tight" style={{ padding: 0, overflow: 'hidden' }}>
      <GiftPassCardHeading title="Activity" detail={eventCountLabel(pass.events.length)} />
      {pass.events.length === 0 ? (
        <div style={{ padding: '18px 16px', fontSize: 12.5, color: 'var(--nb-subtle)' }}>
          No activity recorded for this pass yet.
        </div>
      ) : (
        <ul style={{ listStyle: 'none', margin: '0 0 -1px', padding: 0 }}>
          {pass.events.map((event) => (
            <GiftPassEventItem key={event.id} event={event} source={pass.source} />
          ))}
        </ul>
      )}
    </section>
  );
}
